import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Image, { IImage } from '../Image';
import { ILink } from '../Button';

export interface IOffcanvasProps extends IBaseElementProps {
	children?: any;
	position?: 'start' | 'end' | 'top' | 'bottom';
	heading?: string;
	headingImage?: IImage;
	headingLink?: ILink;
}

const Offcanvas: React.FC<IOffcanvasProps> = ({
	children,
	className,
	classNames = [],
	position = 'end',
	heading,
	headingImage,
	headingLink,
}) => (
	<div
		className={
			className ||
			cn('offcanvas', position && `offcanvas-${position}`, ...classNames)
		}
		tabIndex={-1}
	>
		<div className="offcanvas-header">
			{headingLink ? (
				<a href={headingLink.href} className="offcanvas-header-link">
					{heading && <h5>{heading}</h5>}
					{headingImage && <Image {...headingImage} />}
				</a>
			) : (
				<>
					{heading && <h5>{heading}</h5>}
					{headingImage && <Image {...headingImage} />}
				</>
			)}
			
			<button
				type="button"
				className="btn-close text-reset"
				data-bs-dismiss="offcanvas"
				aria-label="Close"
			></button>
		</div>
		<div className="offcanvas-body">{children}</div>
	</div>
);

export default Offcanvas;
